import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: {
        name: 'home',
        params: {
          locale: 'pl'
        }
      }
    },
    {
      path: '/:locale',
      component: {
        watch: {
          $route: {
            handler (route) {
              this.$i18n.locale = route.params.locale
            },
            immediate: true
          }
        },
        render (c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: ':group',
          component: () =>
            import(/* webpackChunkName: "slides" */ './views/Slides.vue'),
          children: [
            {
              path: '',
              name: 'slides',
              redirect: to => ({
                name: 'slide',
                params: {
                  locale: to.params.locale,
                  group: to.params.group,
                  id: 1
                }
              })
            },
            {
              path: 'raport',
              name: 'raport',
              component: () =>
                import(/* webpackChunkName: "report" */ './views/Report.vue')
            },
            {
              path: 'video',
              name: 'video',
              props: true,
              component: () =>
                import(/* webpackChunkName: "video" */ './views/Video.vue')
            },
            {
              path: ':id',
              name: 'slide',
              component: () =>
                import(/* webpackChunkName: "slide" */ './views/Slide.vue')
            }
          ]
        }
      ]
    }
  ]
})
